module.exports = __webpack_public_path__ + "img/price-calculator-bg.d8367f5.webp";